import React from 'react'

export const AdminBox = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="w-full border border-teal-500 rounded mx-205 desktop:mx-0">
      <div className="bg-teal-500 text-white flex items-center justify-center h-9">
        {I18n.t('shared.admin_box.header')}
      </div>
      <div className="text-center p-4">{children}</div>
    </div>
  )
}
